/**
 * Bug Tracker Mock Data
 */

export interface Bug {
  id: string;
  title: string;
  description: string;
  status: 'open' | 'in-progress' | 'resolved' | 'closed';
  priority: 'critical' | 'high' | 'medium' | 'low';
  assignee: {
    id: string;
    name: string;
    initials: string;
    avatar?: string;
  };
  reporter: {
    id: string;
    name: string;
  };
  dueDate: string;
  createdDate: string;
  tags: string[];
  comments?: number;
  attachments?: number;
}

export const mockBugs: Bug[] = [
  {
    id: 'BUG-001',
    title: 'Login page crashes on mobile devices',
    description: 'The login page is not responsive on mobile devices.',
    status: 'open',
    priority: 'critical',
    assignee: {
      id: 'u1',
      name: 'John Doe',
      initials: 'JD',
    },
    reporter: {
      id: 'u5',
      name: 'Alice Smith',
    },
    dueDate: '2025-10-20',
    createdDate: '2025-10-10',
    tags: ['mobile', 'authentication'],
    comments: 5,
    attachments: 2,
  },
  {
    id: 'BUG-002',
    title: 'Dashboard data not loading correctly',
    description: 'Dashboard widgets show incorrect data after refresh.',
    status: 'in-progress',
    priority: 'high',
    assignee: {
      id: 'u2',
      name: 'Jane Wilson',
      initials: 'JW',
    },
    reporter: {
      id: 'u6',
      name: 'Bob Johnson',
    },
    dueDate: '2025-10-18',
    createdDate: '2025-10-08',
    tags: ['dashboard', 'data'],
    comments: 3,
    attachments: 1,
  },
  {
    id: 'BUG-003',
    title: 'Export functionality missing in reports',
    description: 'Users cannot export reports to PDF format.',
    status: 'resolved',
    priority: 'medium',
    assignee: {
      id: 'u3',
      name: 'Mike Brown',
      initials: 'MB',
    },
    reporter: {
      id: 'u7',
      name: 'Sarah Davis',
    },
    dueDate: '2025-10-25',
    createdDate: '2025-10-05',
    tags: ['reports', 'export'],
    comments: 8,
    attachments: 0,
  },
  {
    id: 'BUG-004',
    title: 'Typo in user settings page',
    description: 'Minor spelling mistake in settings description.',
    status: 'closed',
    priority: 'low',
    assignee: {
      id: 'u4',
      name: 'Emily White',
      initials: 'EW',
    },
    reporter: {
      id: 'u8',
      name: 'Tom Black',
    },
    dueDate: '2025-10-15',
    createdDate: '2025-10-01',
    tags: ['ui', 'text'],
    comments: 2,
    attachments: 1,
  },
];

export const statusOptions = [
  { value: 'all', label: 'All Status' },
  { value: 'open', label: 'Open' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const priorityOptions = [
  { value: 'all', label: 'All Priority' },
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];
